import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { Page } from '../components';
import { reactPlugin } from "../AppInsights";
import { useIntl } from 'react-intl';
import React, { useState } from "react";
import { RootPageSelector } from "../components/RootPageSelector/RootPageSelector";
import { PortfolioInsights, modelId as modelPortfolio } from "../automationObjects/Collections/PortfolioInsights";
import { useGetObjectsWithModelQuery } from "../services/objects";
import { EmptyState } from "../components/EmptyState";
import { IAutomationObject } from "../automationObjects";
import { AccessRoles, useHasRole } from "../hooks/useHasRole";
import { GetAddAppFilter, HasAddAppSupport } from "../automationObjects/automationObjectsSelector";
import { Button } from "baseui/button";
import { ModalAutoSize } from "../components/ModalAutoSize";
import { ObjectCreator } from "../features/ObjectCreator/ObjectCreator";


const BuildingInsightsPage = () => {
    const intl = useIntl();
    const { data, isLoading } = useGetObjectsWithModelQuery({ twinModelId: modelPortfolio });

    const first = data ? data?.length > 0 ? data[0] : undefined : undefined;
    return (
        <Page actionButton={<RootPageSelector />}  bottomButtons={<>{ first && <BottomActionButton app={first}></BottomActionButton>}</>} header={intl.formatMessage({ id: "Pages.BuildingInsights.header", defaultMessage: "Building Insights" })} subheader={intl.formatMessage({ id: "Pages.BuildingInsights.subheader", defaultMessage: "Analyse your portfolio" })}>
            {first &&
                <PortfolioInsights {...first}></PortfolioInsights>
            }
            {(!first && !isLoading) && <EmptyState header={"Not Found"} message={"No App for Portfolio insights found. Contact your admin to create one"} />}
        </Page >
    )
}


export default React.memo(withAITracking(reactPlugin, BuildingInsightsPage));


const BottomActionButton = (props: { app: IAutomationObject }) => {

    const hasCreateRights = useHasRole(AccessRoles.Subscription.Write);
    const [showDialog, setShowDialog] = useState(false);

    if (!props.app)
        return (<></>)

    const hasSupportForThis = HasAddAppSupport(props.app.schema);

    if (!hasCreateRights || !hasSupportForThis)
        return (<></>)


    const myfilter = GetAddAppFilter(props.app.schema);
    return (
        <>
            <Button shape="circle" onClick={() => setShowDialog(true)}>+</Button>
            {showDialog && myfilter !== undefined &&
                <ModalAutoSize
                    isOpen={showDialog}
                    setIsOpen={() => setShowDialog(false)}
                    header={'Create new App'}
                    footer={<></>}
                    body={<ObjectCreator hideTemplates object={props.app} filter={myfilter}></ObjectCreator>
                    }></ModalAutoSize>
            }
        </>
    )
}

